module.exports = __webpack_public_path__ + "img/20220616_new_tokens.33ea3fd1.png";